import type { FileRejection, FileWithPath } from 'react-dropzone'

import { countPdfPages } from '@/modules/projects/components/dialogs/pdfDocuments'
import type { FileDropzoneItem } from '@/modules/upload/types'

const TOO_MANY_PAGES = 'too-many-pages'

const pageLimitRejection = (
  file: FileWithPath,
  pages: number,
  maxPages: number,
): FileRejection => ({
  file,
  errors: [
    {
      code: TOO_MANY_PAGES,
      message: `This file has ${pages} pages. Up to ${maxPages} can be added.`,
    },
  ],
})

// An encrypted or damaged PDF cannot be counted here. lukita counts every file on upload and refuses
// one over the cap, so an uncounted file is let through for the server to decide.
const countPagesIfReadable = (file: File) =>
  countPdfPages(file).catch(() => null)

const checkPageLimit = async (
  file: FileWithPath,
  maxPages: number,
): Promise<FileDropzoneItem> => {
  const pages = await countPagesIfReadable(file)
  return pages !== null && pages > maxPages
    ? pageLimitRejection(file, pages, maxPages)
    : file
}

export const refuseFilesOverPageLimit = (
  files: FileWithPath[],
  maxPages: number,
) => Promise.all(files.map((file) => checkPageLimit(file, maxPages)))
